import React from "react";
import { useNavigate } from "react-router-dom";
import VisibleHook from "../../../../tool/visibleHook";
import styles from "./index.module.scss";
import { classNames } from "../../../../tool";

const SideNav = (props) => {
  const navigate = useNavigate();
  const navList = [
    {
      title: "投注记录",
      link: "/order",
    },
    {
      title: "玩法说明",
      link: "/gameDesc",
    },
  ];
  const { visible, handleHide } = props;
  const { containerVisible, contentVisible } = VisibleHook({ visible });

  return (
    <div
      className={classNames(
        styles.container,
        containerVisible ? styles.showMask : ""
      )}
      onClick={handleHide}
    >
      <div
        className={classNames(
          styles.content,

          (visible ? contentVisible : visible) ? styles.show : ""
        )}
      >
        {navList.map((item, index) => {
          return (
            <div
              className={styles.navItem}
              key={index}
              onClick={() => {
                navigate(item.link);
              }}
            >
              {item.title}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SideNav;
